
export const UrlConstants = {

    // All api URLs and other urls will go here.
}
